import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AddDocumentDialogContainerComponent } from '../components/add-document-dialog-container/add-document-dialog-container.component';
import { AddDocumentsDialogOptions } from '../models/add-document-dialog-options.model';

@Injectable({
  providedIn: 'root',
})
export class AddDocumentDialogService {
  constructor(private dialog: MatDialog) {}

  upload<T>(options?: Partial<AddDocumentsDialogOptions>, width: string = '510px'): Observable<T | boolean> {
    const dialogOptions: MatDialogConfig = {
      width,
      disableClose: false,
      panelClass:
        options.currentThemeMode === 'dark'
          ? ['dark-theme', 'add-document-dialog']
          : ['light-theme', 'add-document-dialog'],
      autoFocus: false,
      data: options,
    };

    return this.dialog.open(AddDocumentDialogContainerComponent, dialogOptions).beforeClosed();
  }
}
